import {Component} from '@angular/core';
import {UploadService} from './services/upload.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Computational Biomedicine Lab';
  createVideo = false;

  constructor(public uploadService: UploadService) {
  }

  onSelectionChange(uploadWay): void {
    this.createVideo = uploadWay === 'createVideo';
  }

}
